import { InfiniteData, useInfiniteQuery } from 'react-query';
import { useContext } from 'react';
import { ChangeGuardianClientContext, defaultQueryRetry } from '../../../client/ChangeGuardianClientProvider';
import { AWSError } from 'aws-sdk';
import { PromiseResult } from 'aws-sdk/lib/request';
import { ChangeGuardianApprovalService } from '@amzn/change-guardian-approval-service-type-script-client';

export default (
  reviewId: string,
  maxResults: number | undefined,
  onSuccess?: (
    data: InfiniteData<PromiseResult<ChangeGuardianApprovalService.ListResourceRevisionsByReviewOutput, AWSError>>
  ) => void,
  onError?: (err: AWSError) => void
) => {
  const client = useContext(ChangeGuardianClientContext);
  return useInfiniteQuery(
    ['listResourceRevisionsByReview', reviewId, maxResults],
    ({ pageParam = undefined }) => {
      return client
        ?.listResourceRevisionsByReview({
          reviewId,
          maxResults,
          nextToken: pageParam as string
        })
        .promise();
    },
    {
      onSuccess,
      onError,
      getNextPageParam: (result) => result?.nextToken,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: defaultQueryRetry
    }
  );
};
